import React from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const InfoToggle = ({
  label,
  openState,
  handleToggle,
  id = null, // Ahora el id es opcional
  iconStyle = {},
  labelStyle = {},
  showChevron = true,
  color = '#007bff', // Color por defecto
  'data-testid': dataTestId,
}) => {
  // Determinar si openState es un objeto indexado por id o un booleano
  const isOpen = id ? openState[id] : openState;

  return (
    <span
      data-testid={dataTestId || `info-toggle-${id || 'default'}`}
      onClick={() => showChevron && handleToggle(id)}
      style={{
        cursor: showChevron ? 'pointer' : 'default',
        fontWeight: 'bold',
        color: color, // Usamos el color pasado como propiedad o el predeterminado
        ...labelStyle,
      }}
    >
      {label}
      {showChevron && isOpen ? (
        <FaChevronUp className="chevron-icon" data-testid={`chevron-up-${id || 'default'}`} style={{ marginLeft: '10px', ...iconStyle }} />
      ) : showChevron ? (
        <FaChevronDown className="chevron-icon" data-testid={`chevron-down-${id || 'default'}`} style={{ marginLeft: '10px', ...iconStyle }} />
      ) : null}
    </span>
  );
};

export default InfoToggle;
